import { useLocation, useNavigate } from 'react-router-dom';
import { Box } from 'grommet';
import { Action, BarChart, Calculator, DocumentUpload, Group, System } from 'grommet-icons';
import { observer } from 'mobx-react-lite';
import { Text } from '/src/components/common';

const AdminSideNav = observer(() => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { icon: <System color="dark-3" size="20px" />, label: 'Dashboard', path: '/fuse-admin' },
    { icon: <DocumentUpload color="dark-3" size="20px" />, label: 'Importer', path: '/fuse-admin/importer' },
    { icon: <BarChart color="dark-3" size="20px" />, label: 'Credit Pricing', path: '/fuse-admin/credit-pricing' },
    {
      icon: <Calculator color="dark-3" size="20px" />,
      label: 'Credit Calculation',
      path: '/fuse-admin/credit-calculation',
    },
    { icon: <Group color="dark-3" size="20px" />, label: 'Referral Partners', path: '/fuse-admin/referral-partners' },
    { icon: <Action color="dark-3" size="20px" />, label: 'Charging Networks', path: '/fuse-admin/charging-networks' },
    // { icon: <CreditCard color="dark-3" size="20px" />, label: 'Stripe Remittance', path: '/fuse-admin/remittance' },
    // { icon: <DocumentText color="dark-3" size="20px" />, label: 'Reports', path: '/fuse-admin/reports' },
    // { icon: <Location color="dark-3" size="20px" />, label: 'Programs', path: '/fuse-admin/programs' },
    // { icon: <Calculator color="dark-3" size="20px" />, label: 'Broker Commission', path: '/fuse-admin/broker-commission' },
    // { icon: <Lock color="dark-3" size="20px" />, label: 'Security Settings', path: '/fuse-admin/security-settings' },
    // { icon: <Bug color="dark-3" size="20px" />, label: 'System Logs', path: '/fuse-admin/system-logs' },
  ];

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <Box
      width="260px"
      background="white"
      elevation="none"
      pad={{ vertical: 'medium' }}
      border={{ color: 'light-4', size: 'px' }}
    >
      {navItems.map((item) => (
        <Box
          key={item.label}
          pad={{ horizontal: 'medium', vertical: 'small' }}
          background={isActive(item.path) ? { color: 'light-4', opacity: 'strong' } : 'white'}
          onClick={() => navigate(item.path)}
          hoverIndicator={{ color: 'light-4', opacity: 'strong' }}
          direction="row"
          align="center"
          gap="medium"
          round="small"
          margin={{ vertical: '3px', horizontal: 'small' }}
        >
          <Box width="24px" align="center">
            {item.icon}
          </Box>
          <Text color="dark-1" size="medium" weight={isActive(item.path) ? 500 : 'normal'}>
            {item.label}
          </Text>
        </Box>
      ))}

      {/* <Box pad={{ horizontal: 'medium', vertical: 'medium' }} align="center" margin={{ top: 'auto' }}>
        <Text color="status-critical" size="medium">
          * Some pages include mock up data/components *
        </Text>
      </Box> */}
    </Box>
  );
});

export default AdminSideNav;
